import React from 'react';
import {
  Box,
  Container,
  Grid2,
  Typography,
  Link,
  useTheme,
  Stack,
  Divider,
  IconButton,
  Tooltip,
} from '@mui/material';
import { LinkedIn, GitHub, Instagram } from '@mui/icons-material';
import XIcon from '@mui/icons-material/X';
import { useTranslation } from 'react-i18next';
import GradientLogo from '../ui/Logo/GradientLogo';

const Footer = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: t('footer.socialLinks.linkedin'),
      icon: <LinkedIn />,
      url: 'https://linkedin.com',
      color: '#0077B5',
    },
    {
      name: t('footer.socialLinks.twitter'),
      icon: <XIcon />,
      url: 'https://x.com',
      color: theme.palette.mode === 'dark' ? '#ffffff' : '#000000',
    },
    {
      name: t('footer.socialLinks.github'),
      icon: <GitHub />,
      url: 'https://github.com',
      color: theme.palette.mode === 'dark' ? '#fff' : '#333',
    },
    {
      name: t('footer.socialLinks.instagram'),
      icon: <Instagram />,
      url: 'https://instagram.com',
      color: '#E4405F',
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid2 container spacing={4} alignItems="center">
          <Grid2 size={{ xs: 12, md: 8 }}>
            <Box sx={{ mb: 2 }}>
              <GradientLogo isMobile={false} />
            </Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 2, maxWidth: '400px' }}
            >
              {t('footer.tagline')}
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 4 }}>
            <Box sx={{ textAlign: { xs: 'left', md: 'right' } }}>
              <Typography
                variant="h6"
                color="text.primary"
                fontWeight={600}
                sx={{ mb: 2 }}
              >
                {t('footer.followUs')}
              </Typography>
              <Stack
                direction="row"
                spacing={1}
                sx={{ justifyContent: { xs: 'flex-start', md: 'flex-end' } }}
              >
                {socialLinks.map((social, index) => (
                  <Tooltip key={index} title={social.name}>
                    <IconButton
                      component={Link}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: 'text.secondary',
                        '&:hover': {
                          color: social.color,
                          transform: 'translateY(-2px)',
                        },
                        transition: 'all 0.2s ease-in-out',
                      }}
                    >
                      {social.icon}
                    </IconButton>
                  </Tooltip>
                ))}
              </Stack>
            </Box>
          </Grid2>
        </Grid2>
        <Divider sx={{ my: 4, color: theme.palette.divider }} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="body2" color="text.secondary" align="center">
            {t('footer.copyright', { year: currentYear })}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
